import * as React from 'react';
import { createRelatedGeoAreasByIdSelector } from '@/redux/modules/geoArea/geoArea.selectors';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { H2 } from '@liveauctioneers/hammer-ui-core/text';
import { RelatedGeoArea } from '@/types/GeoArea';
import { useAppSelector } from '@/redux/hooks';
import GeoRelatedArea from './components/Card/RelatedGeoAreaCard';
import styled from 'styled-components';

type Props = {
    className?: string;
    geoAreaId: number;
};

const RelatedGeoAreas = ({ className, geoAreaId }: Props) => {
    const geoRelatedAreasRedux = useAppSelector(createRelatedGeoAreasByIdSelector(Number(geoAreaId)));

    const mapRelatedAreas = React.useCallback(
        ({ geoAreaId, geoAreaName }: RelatedGeoArea) => (
            <GeoRelatedArea
                displayName={geoAreaName}
                geoAreaID={geoAreaId}
                key={geoAreaName}
            />
        ),
        []
    );
    let geoAreaCards = [];
    if (geoRelatedAreasRedux?.length) {
        geoAreaCards = geoRelatedAreasRedux.map(mapRelatedAreas);
    }

    if (geoAreaCards.length > 0) {
        return (
            <StyledRelatedSearchCarousel
                className={className}
                data-testid="Geo-Related-Areas-Carousel"
            >
                <H2 className="my-[20px] block">
                    <FormattedMessage id="relatedAreasCarouselTitle" />
                </H2>
                <StyledCardsHolder>{geoAreaCards}</StyledCardsHolder>
            </StyledRelatedSearchCarousel>
        );
    }
    return null;
};

export default React.memo<Props>(RelatedGeoAreas);

const StyledRelatedSearchCarousel = styled.div`
    margin: 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidthNum + 1}px) {
        margin: 30px 0 0;
    }
`;

const StyledCardsHolder = styled.section`
    display: flex;
    flex-wrap: wrap;
`;
